import React, { useRef, useState, useEffect } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope
} from "@fortawesome/free-solid-svg-icons";
import voltupLogo from "../../assets/images/voltup-logo.png";
import "./../../assets/css/otp-component.css";
import { useVerifyEmailMutation } from "../api/verifyEmailApiSlice";
import Loading from "./Loading";

const VerifyEmailCard = (props) => {
  const emailRef = useRef();
  const errRef = useRef();
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [verifyEmail, { isLoading }] = useVerifyEmailMutation();

  useEffect(() => {
    setErrorMessage("");
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    setDisableSubmit(!isEmailValid);
  }, [email]);
  

  useEffect(() => {
    if (errorMessage !== "") {
      setDisableSubmit(true);
    }
  }, [errorMessage]);

  const handleEmailInput = (e) => {
    setEmail(e.target.value);
  };

  if (isLoading) {
    return <Loading />;
  }

  const handleNext = async (e) => {
    e.preventDefault();
    try {
      let response = await verifyEmail({ email: email }).unwrap();
      props.onSuccess(email, response.data.mobile_number);
    } catch (err) {
      setErrorMessage(err.data.message);
    }
  };
  
  return (
    <React.Fragment>
        <Card className="login-card">
          <Card.Img variant="top" src={voltupLogo} />
          <Card.Body>
            <Row>
              <Col md={{ span: 10, offset: 1 }}>
                <div className="text-danger" ref={errRef}>{errorMessage}</div>
                <Row className="mb-4">
                  <Col>
                    <h4>Start by entering your email</h4>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col>
                    <div className="input-icon-wrapper">
                      <FontAwesomeIcon className="icon-left" icon={faEnvelope} />
                      <input
                        type="text"
                        ref={emailRef}
                        value={email}
                        onChange={handleEmailInput}
                        placeholder="Enter Email Adress"
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col>
                    <button onClick={props.onBackClick} className="btn">Back</button>
                  </Col>
                  <Col>
                    <button
                      onClick={handleNext}
                      disabled={disableSubmit}
                      className="btn"
                    >
                      Next
                    </button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card.Body>
        </Card>
    </React.Fragment>
  );
};

export default VerifyEmailCard;
